import styled from "styled-components";
import {bulbClassicLightBg} from "../../../wheel-color-helper";

export const LightEmittedDefaultBox = styled.div<{boxShadowBlurSize: number;}>`
    position: absolute;
    width: 180%;
    height: 180%;
    top: -40%; /** Rule, top and left value are (width - 100)/2 */
    left: -40%;
    border-radius: 50%;
    background-color: ${bulbClassicLightBg};
    box-shadow: ${bulbClassicLightBg} 0px 0px ${props => props.boxShadowBlurSize}px 0px;
    filter: blur(2px);
    transition: background-color, box-shadow 0.15s ease;
`;
